import { EventEmitter } from "@angular/core";

export class AppEvents {
  static beforeRequest = new EventEmitter();
  static afterRequest = new EventEmitter();
  static schoolYearChanged = new EventEmitter();
}
